import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1e8f4b74&scoped=true"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1e8f4b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f4b74",
  null
  
)

export default component.exports